module.exports = __webpack_public_path__ + "img/OHNE_ABBILDUNG_SESAM.86e53c3f.jpg";